// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3aq6w","rootNoMargin":"styles_rootNoMargin__1DKVi"};